import { usePageMeta } from 'src/hooks';
import { ResourceList } from 'src/components/Resource/List';
import { ResourceCard } from 'src/components/Resource/Card';

import { contactUsItems } from './model';

export default function ContactUs() {
  usePageMeta('Contact Us');

  return (
    <div className="container mx-auto">
      <ResourceList className="gap-6">
        {contactUsItems.map((item, index) => (
          <ResourceCard key={index} {...item} />
        ))}
      </ResourceList>
    </div>
  );
}
